var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Instruction, InstructionHeader, InstructionsContainer } from './subcomponents';
var CertificatesInstructions = function (_a) {
    var _b = _a.alignment, alignment = _b === void 0 ? 'center' : _b, body = _a.body, header = _a.header;
    return (_jsxs(InstructionsContainer, __assign({ alignment: alignment }, { children: [_jsx(InstructionHeader, { children: header }), _jsx(Instruction, { children: body })] })));
};
export default CertificatesInstructions;
